/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import React from "react";
import { Checkbox, Grid, Tooltip, makeStyles } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import "./AcceptTerms.scss";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

/**
 *
 * @summery to render accept terms and conditions check box
 */
interface IProps {
  onTermsAccept: (event: any) => void;
  isTermsAccepted?: boolean;
  isFormFilled?: boolean;
}
const AcceptTerms = (props: IProps) => {
  const checkboxColor =
    !props.isTermsAccepted && props.isFormFilled ? "#EE3426" : "#F0F0F0";

  return (
    <Grid container className="accept-terms-grid">
      <Tooltip
        title="Please agree to the user consent to proceed."
        arrow
        open={!props.isTermsAccepted && props.isFormFilled}
        placement="bottom-start"
      >
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          className="terms-checkbox"
          style={{
            marginRight: 8,
            marginLeft: "3vw",
            height: "1vh",
            width: "1vh",
            // minHeight: "10px",
            color: `${checkboxColor}`,
          }}
          onChange={(event) =>
            props.onTermsAccept && props.onTermsAccept(event)
          }
        />
      </Tooltip>
      <label className="terms-label">
        I have received consent from the user to add personal details on the
        user’s behalf into this system.
      </label>
    </Grid>
  );
};

export default AcceptTerms;
